export const CONTAINER_TYPES = {
  RFIS: 'rfi',
  REPORT: 'report',
};
